import { transparentize } from "polished";
import { Colors, ContentColorModeVariants } from "./enums";
export const rawColorValues = {
    [Colors.black]: ["#000000", "#191919"],
    [Colors.white]: ["#ffffff"],
    [Colors.grey]: [
        "#262626",
        "#53565a",
        "#b1b3b3",
        "#e5e8e9",
        "#F4F4F4",
        "#FBFBFB"
    ],
    [Colors.green]: ["#1E5530", "#153A21"],
    [Colors.yellow]: ["#FFA800"],
    [Colors.red]: ["#C63439", "#9E0303", "#7D0303", "#E5BFC0"],
    [Colors.blue]: ["#144A7F", "#082644", "#051E34", "#ACB3B8"]
};
export const processColorMode = (cm, bgOverride = "", colorOverride = "") => {
    switch (cm) {
        case "light":
            return {
                color: colorOverride && colorOverride.length > 0
                    ? transparentize(0.2, colorOverride)
                    : ContentColorModeVariants.textSupportingLight,
                borderTopColor: colorOverride && colorOverride.length > 0
                    ? colorOverride
                    : ContentColorModeVariants.borderLight,
                borderBottomColor: colorOverride && colorOverride.length > 0
                    ? colorOverride
                    : ContentColorModeVariants.borderLight,
                borderLeftColor: colorOverride && colorOverride.length > 0
                    ? colorOverride
                    : ContentColorModeVariants.borderLight,
                borderRightColor: colorOverride && colorOverride.length > 0
                    ? colorOverride
                    : ContentColorModeVariants.borderLight,
                bg: bgOverride && bgOverride.length > 0
                    ? bgOverride
                    : ContentColorModeVariants.bgLight,
                " .color-mode-title": {
                    color: colorOverride && colorOverride.length > 0
                        ? colorOverride
                        : ContentColorModeVariants.textTitleLight
                },
                " a": {
                    color: colorOverride && colorOverride.length > 0
                        ? colorOverride
                        : ContentColorModeVariants.textLinkLight
                },
                " a:hover": {
                    color: colorOverride && colorOverride.length > 0
                        ? colorOverride
                        : ContentColorModeVariants.textTitleLight
                },
                " .color-mode-title a": {
                    color: colorOverride && colorOverride.length > 0
                        ? colorOverride
                        : ContentColorModeVariants.textSupportingLight
                },
                " .color-mode-title a:hover": {
                    color: colorOverride && colorOverride.length > 0
                        ? colorOverride
                        : ContentColorModeVariants.textSupportingLight
                }
            };
        case "dark":
            return {
                color: colorOverride && colorOverride.length > 0
                    ? transparentize(0.2, colorOverride)
                    : ContentColorModeVariants.textSupportingDark,
                borderTopColor: colorOverride && colorOverride.length > 0
                    ? colorOverride
                    : ContentColorModeVariants.borderDark,
                borderBottomColor: colorOverride && colorOverride.length > 0
                    ? colorOverride
                    : ContentColorModeVariants.borderDark,
                borderLeftColor: colorOverride && colorOverride.length > 0
                    ? colorOverride
                    : ContentColorModeVariants.borderDark,
                borderRightColor: colorOverride && colorOverride.length > 0
                    ? colorOverride
                    : ContentColorModeVariants.borderDark,
                bg: bgOverride && bgOverride.length > 0
                    ? bgOverride
                    : ContentColorModeVariants.bgDark,
                " .color-mode-title": {
                    color: colorOverride && colorOverride.length > 0
                        ? colorOverride
                        : ContentColorModeVariants.textTitleDark
                },
                " a": {
                    color: colorOverride && colorOverride.length > 0
                        ? colorOverride
                        : ContentColorModeVariants.textLinkDark
                },
                " a:hover": {
                    color: colorOverride && colorOverride.length > 0
                        ? colorOverride
                        : ContentColorModeVariants.textTitleDark
                },
                " .color-mode-title a": {
                    color: colorOverride && colorOverride.length > 0
                        ? colorOverride
                        : ContentColorModeVariants.textTitleDark
                },
                " .color-mode-title a:hover": {
                    color: colorOverride && colorOverride.length > 0
                        ? colorOverride
                        : ContentColorModeVariants.textTitleDark
                }
            };
        case "mid":
            return {
                color: colorOverride && colorOverride.length > 0
                    ? transparentize(0.2, colorOverride)
                    : ContentColorModeVariants.textSupportingLight,
                borderTopColor: colorOverride && colorOverride.length > 0
                    ? colorOverride
                    : ContentColorModeVariants.borderMid,
                borderBottomColor: colorOverride && colorOverride.length > 0
                    ? colorOverride
                    : ContentColorModeVariants.borderMid,
                borderLeftColor: colorOverride && colorOverride.length > 0
                    ? colorOverride
                    : ContentColorModeVariants.borderMid,
                borderRightColor: colorOverride && colorOverride.length > 0
                    ? colorOverride
                    : ContentColorModeVariants.borderMid,
                bg: bgOverride && bgOverride.length > 0
                    ? bgOverride
                    : ContentColorModeVariants.bgMid,
                "& .color-mode-title": {
                    color: colorOverride && colorOverride.length > 0
                        ? colorOverride
                        : ContentColorModeVariants.textTitleLight
                },
                "& a": {
                    color: colorOverride && colorOverride.length > 0
                        ? colorOverride
                        : ContentColorModeVariants.textLinkLight
                },
                "& a:hover": {
                    color: colorOverride && colorOverride.length > 0
                        ? colorOverride
                        : ContentColorModeVariants.textTitleLight
                },
                "& .color-mode-title a": {
                    color: colorOverride && colorOverride.length > 0
                        ? colorOverride
                        : ContentColorModeVariants.textSupportingLight
                },
                "& .color-mode-title a:hover": {
                    color: colorOverride && colorOverride.length > 0
                        ? colorOverride
                        : ContentColorModeVariants.textSupportingLight
                }
            };
        default:
            return {
                color: colorOverride && colorOverride.length > 0
                    ? transparentize(0.2, colorOverride)
                    : ContentColorModeVariants.textSupportingLight,
                borderTopColor: colorOverride && colorOverride.length > 0
                    ? colorOverride
                    : ContentColorModeVariants.borderLight,
                borderBottomColor: colorOverride && colorOverride.length > 0
                    ? colorOverride
                    : ContentColorModeVariants.borderLight,
                borderLeftColor: colorOverride && colorOverride.length > 0
                    ? colorOverride
                    : ContentColorModeVariants.borderLight,
                borderRightColor: colorOverride && colorOverride.length > 0
                    ? colorOverride
                    : ContentColorModeVariants.borderLight,
                bg: bgOverride && bgOverride.length > 0
                    ? bgOverride
                    : ContentColorModeVariants.bgLight,
                " .color-mode-title": {
                    color: colorOverride && colorOverride.length > 0
                        ? colorOverride
                        : ContentColorModeVariants.textTitleLight
                },
                " a": {
                    color: colorOverride && colorOverride.length > 0
                        ? colorOverride
                        : ContentColorModeVariants.textLinkLight
                },
                " a:hover": {
                    color: colorOverride && colorOverride.length > 0
                        ? colorOverride
                        : ContentColorModeVariants.textTitleLight
                },
                " .color-mode-title a": {
                    color: colorOverride && colorOverride.length > 0
                        ? colorOverride
                        : ContentColorModeVariants.textSupportingLight
                },
                " .color-mode-title a:hover": {
                    color: colorOverride && colorOverride.length > 0
                        ? colorOverride
                        : ContentColorModeVariants.textSupportingLight
                }
            };
    }
};
export const ThemeColors = {
    [Colors.black]: rawColorValues[Colors.black],
    [Colors.white]: rawColorValues[Colors.white],
    [Colors.grey]: rawColorValues[Colors.grey],
    [Colors.green]: rawColorValues[Colors.green],
    [Colors.yellow]: rawColorValues[Colors.yellow],
    [Colors.red]: rawColorValues[Colors.red],
    [Colors.blue]: rawColorValues[Colors.blue],
    // The following keys are required according to spec
    background: rawColorValues[Colors.white][0],
    softBackground: rawColorValues[Colors.grey][4],
    primary: rawColorValues[Colors.blue][0],
    secondary: rawColorValues[Colors.red][0],
    accent: rawColorValues[Colors.blue][1],
    heading: rawColorValues[Colors.black][1],
    text: rawColorValues[Colors.grey][0],
    muted: rawColorValues[Colors.grey][1],
    stroke: rawColorValues[Colors.grey][3],
    // content components - a component has its own dark or light mode
    //which in turn is affected by the overall theme color mode
    [ContentColorModeVariants.bgDark]: rawColorValues[Colors.black][1],
    [ContentColorModeVariants.bgMid]: rawColorValues[Colors.grey][4],
    [ContentColorModeVariants.bgLight]: rawColorValues[Colors.white][0],
    [ContentColorModeVariants.borderDark]: rawColorValues[Colors.grey][1],
    [ContentColorModeVariants.borderMid]: rawColorValues[Colors.grey][3],
    [ContentColorModeVariants.borderLight]: rawColorValues[Colors.grey][3],
    [ContentColorModeVariants.textTitleLight]: rawColorValues[Colors.black][1],
    [ContentColorModeVariants.textSupportingLight]: rawColorValues[Colors.grey][1],
    [ContentColorModeVariants.textLinkLight]: rawColorValues[Colors.black][1],
    [ContentColorModeVariants.textTitleMid]: rawColorValues[Colors.grey][1],
    [ContentColorModeVariants.textSupportingMid]: rawColorValues[Colors.grey][1],
    [ContentColorModeVariants.textLinkMid]: rawColorValues[Colors.black][1],
    [ContentColorModeVariants.textTitleDark]: rawColorValues[Colors.white][0],
    [ContentColorModeVariants.textSupportingDark]: rawColorValues[Colors.grey][2],
    [ContentColorModeVariants.textLinkDark]: rawColorValues[Colors.grey][2]
};
/*
  modes: {
    dark: {
      [ContentColorModeVariants.bgLight]: rawColorValues[Colors.grey][0],
      [ContentColorModeVariants.bgMid]: rawColorValues[Colors.white][0],
      [ContentColorModeVariants.bgDark]: rawColorValues[Colors.blue][2],

      [ContentColorModeVariants.borderDark]: rawColorValues[Colors.grey][2],
      [ContentColorModeVariants.borderMid]: rawColorValues[Colors.grey][3],
      [ContentColorModeVariants.borderLight]: rawColorValues[Colors.grey][3],

      [ContentColorModeVariants.textTitleLight]: rawColorValues[Colors.blue][0],
      [ContentColorModeVariants.textLinkLight]: rawColorValues[Colors.grey][1],
      [ContentColorModeVariants.textSupportingLight]:
        rawColorValues[Colors.grey][1],

      [ContentColorModeVariants.textTitleDark]: rawColorValues[Colors.white][0],
      [ContentColorModeVariants.textLinkDark]: rawColorValues[Colors.grey][0],
      [ContentColorModeVariants.textSupportingDark]:
        rawColorValues[Colors.grey][2],

      [ContentColorModeVariants.textTitleMid]: rawColorValues[Colors.blue][0],
      [ContentColorModeVariants.textLinkMid]: rawColorValues[Colors.grey][1],
      [ContentColorModeVariants.textSupportingMid]:
        rawColorValues[Colors.grey][1]
    }
  }
*/
//# sourceMappingURL=colors.js.map